import React from 'react';
import { lighten, withStyles, LinearProgress } from "@material-ui/core";
import green from '@material-ui/core/colors/green';

const COLOR_GREEN = green[500];

const BorderLinearProgressGreen = withStyles({
  root: {
    height: 5,
    backgroundColor: lighten(COLOR_GREEN, 0.5),
  },
  bar: {
    borderRadius: 20,
    backgroundColor: COLOR_GREEN,
  },
})(LinearProgress);

export interface ProgressBarProps {
  barStyles?: string;
  value: number;
}

const ProgressBarGreenish = (props: ProgressBarProps) => (
  <BorderLinearProgressGreen
        className={props.barStyles}
        variant="determinate"
        color="primary"
        value={props.value}
      />
);

export default ProgressBarGreenish;
